<template>
<div>

  <div class="wrapper-share-section">
     <div class="menu-screen-headline">Share Brees' Career</div>
     <div class="wrapper-share-contest-links">
	      <a href="" data-js="facebook-share" @click="fbShare" class="share-icon share-icon-facebook"><i class="fa fa-facebook-square"></i> Facebook</a>
	      <a href="" data-js="twitter-share" @click="twitterShare" class="share-icon share-icon-twitter"><i class="fa fa-twitter-square"></i> Twitter</a>
	      <a href="mailto:?subject=Drew Brees - Over the Years - Records and Stats&body=Check out Drew Brees' stats and records over his current 18 year career. How does Drew Brees stack up against the NFL greats? | https://www.GoMarchingIn.com" @click="emailShare" class="share-icon share-icon-email"><i class="fa fa-envelope-square"></i> Email</a>
    </div>


    


  </div>

<!--<form id="mktoForm_2069"></form>-->



    <div class="wrapper-subscribe-section">
     <div class="menu-screen-headline" style="margin-bottom: 20px;">Subscribe to the Saints</div>
     <div class="wrapper-share-contest-links">
      <a href="https://www.neworleanssaints.com/news/email-newsletter" @click="wentToNewsletter" class="subscribe-icon subscribe-icon-facebook" target="_blank"><i class="fa fa-envelope-square"></i> Saints Newsletter</a>
	      <a href="https://www.facebook.com/neworleanssaints/" data-js="facebook-share" class="subscribe-icon subscribe-icon-facebook" target="_blank"><i class="fa fa-facebook-square"></i> Facebook</a>
	      <a href="https://twitter.com/Saints" data-js="twitter-subscribe" class="subscribe-icon subscribe-icon-twitter" target="_blank"><i class="fa fa-twitter-square"></i> Twitter</a>
	      <a href="https://www.youtube.com/c/NewOrleansSaints" data-js="google-subscribe" class="subscribe-icon subscribe-icon-google" target="_blank"><i class="fa fa-youtube"></i> YouTube</a>
	      <a href="https://www.instagram.com/saints/" data-js="google-subscribe" class="subscribe-icon subscribe-icon-google" target="_blank"><i class="fa fa-instagram"></i> Instagram</a>
	      
    </div>
  </div>



  <div class="wrapper-visit-website-section">
    
     <img class="saints-logo" src="https://static.www.nfl.com/t_q-best/league/api/clubs/logos/NO">
     <a href="https://www.neworleanssaints.com/" class="visit-external-link" target="_blank" @click="wentToSaintsCom">
     <div class="visit-website-text">Visit NewOrleansSaints.com</div>
 	</a>
  </div>


</div>
</template>

<script>

export default {
  components: {

  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    onShowModal(){
      this.showModal = true;
    },

    fbShare() {
      this.$ga.event({
        eventCategory: 'Facebook Button',
        eventAction: 'shared',
        eventValue: '1'
      })
    },
    twitterShare() {
      this.$ga.event({
        eventCategory: 'Twitter Button',
        eventAction: 'shared',
        eventValue: '1'
      })
    },
    emailShare() {
      this.$ga.event({
        eventCategory: 'Email Button',
        eventAction: 'shared',
        eventValue: '1'
      })
    },
    wentToSaintsCom() {
      this.$ga.event({
        eventCategory: 'NewOrleansSaints.com Link',
        eventAction: 'Went to Website',
        eventValue: '1'
      })
    },
    wentToNewsletter() {
      this.$ga.event({
        eventCategory: 'Newsletter Button',
        eventAction: 'Went to Newsletter Page on NewOrleansSaints.com',
        eventValue: '1'
      })
    }
},


mounted () {

//Add Marketo Form in Vue.js

// var script   = document.createElement("script");
// script.type  = "text/javascript";
// script.src   = "//app-ab13.marketo.com/js/forms2/js/forms2.min.js";    // use this for linked script
// document.body.appendChild(script);

// setTimeout(() => {
// var script2   = document.createElement("script");
// script2.type  = "text/javascript";
// script2.text  = "MktoForms2.loadForm('//app-ab13.marketo.com', '204-HUD-558', 2069)";
// document.body.appendChild(script2);
// }, 1000)




var facebookShare = document.querySelector('[data-js="facebook-share"]');

facebookShare.onclick = function(e) {
  var facebookWindow = window.open('https://www.facebook.com/sharer/sharer.php?u=' + document.URL, 'facebook-popup', 'height=350,width=600');
  if(facebookWindow.focus) { facebookWindow.focus(); }
    return false;
}

var twitterShare = document.querySelector('[data-js="twitter-share"]');

https://plus.google.com/share?url={url}&text={text}&hl={language_code}

twitterShare.onclick = function(e) {
  e.preventDefault();
  var twitterWindow = window.open('https://twitter.com/share?url=' + document.URL, 'twitter-popup', 'height=350,width=600');
  if(twitterWindow.focus) { twitterWindow.focus(); }
    return false;
  }

var googleShare = document.querySelector('[data-js="google-share"]');

googleShare.onclick = function(e) {
  e.preventDefault();
  var googleWindow = window.open('https://plus.google.com/share?url=' + document.URL, 'google-popup', 'height=350,width=600');
  if(googleWindow.focus) { googleWindow.focus(); }
    return false;
  }


}
}
</script>

<style>

.saints-logo {
  width: 240px;
}



.wrapper-share-section {
	background-color: #d3bc8c;
    padding: 20px 20px;
}

.wrapper-subscribe-section {
 padding: 20px 20px;
}

.visit-external-link {
  display:flex;
  justify-content:space-around;
  align-items: center;
  flex-direction:column;
}

.visit-external-link {
	color:black;
}


.menu-screen-headline {
    font-family: 'Teko', sans-serif;
    font-size: 84px;
}

.copy {
	color:white;
}

.wrapper-visit-website-section {
    background-color: white;
    color: black;
    font-family: 'Teko', sans-serif;
    font-size: 84px;
}


.menu-screen-headline {
    color: white;
    font-size: 100px;
    line-height: 75px;
    padding-top: 20px;
}

.wrapper-share-contest-links {
  display:flex;
  justify-content:space-around;
  align-items: center;
  flex-wrap:wrap;
}

.subscribe-icon {
    color: #d3bc8b;
    background: #313131;
    font-family: 'Teko', sans-serif;
    font-size: 46px;
    width:18%;
    height:50px;
    padding: 5px 10px;
    border-radius: 3px;
    margin-bottom: 10px;
    display:flex;
    justify-content:center;
    align-items:center;
    font-size:32px;
    text-decoration:none;
    line-height: 25px;
    transition-duration: 200ms;
}

.subscribe-icon:hover {
    background: #202020;
    transition-duration: 200ms;
}

.subscribe-icon > i {
    margin-right: 10px;
}

.share-icon {
	font-family: 'Teko', sans-serif;
    font-size: 84px;
	color:white;
    width:30%;
    height:50px;
    padding: 5px 10px;
    border-radius: 3px;
    margin-bottom: 10px;
    display:flex;
  justify-content:center;
  align-items:center;
  font-size:32px;
  text-decoration:none;
}

.share-icon > i {
    margin-right: 10px;
}

.share-icon:hover {
    color: #d9d9d9;
}

.share-icon-facebook {
  background-color: #3B5998;
}
.share-icon-twitter {
  background-color: #1DA1F2;
}
.share-icon-google {
  background-color: #DB4437;
}
.share-icon-email {
  background-color: #aaaaaa;
}
.share-icon-copy {
  background-color: #3b9871;
}

.thank-you-share-headline {
    font-family: 'Poppins', sans-serif;
    margin-bottom: 20px;
    font-weight: 700;
}


@media (max-width:1023px) {
.subscribe-icon {
    width: 45%;
}

.visit-website-text {
font-size:50px;	
}
}


@media (max-width:500px) {
.subscribe-icon {
    width: 90%;
}
.menu-screen-headline {
    font-size: 71px;
    line-height: 57px;
}

.visit-website-text {
    font-size: 30px;
}
.share-icon {
    width: 100%;
    padding: 0px;
}
.wrapper-share-contest-links {
    flex-direction: column;
}
}
</style>


// WEBPACK FOOTER //
// src/views/MenuScreen.vue